import { render, staticRenderFns } from "./menuIcon1.vue?vue&type=template&id=c267a784&scoped=true&"
var script = {}
import style0 from "./menuIcon1.vue?vue&type=style&index=0&id=c267a784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c267a784",
  null
  
)

export default component.exports